import { render, staticRenderFns } from "./DivideCodePage.vue?vue&type=template&id=74087b1f&scoped=true"
import script from "./DivideCodePage.vue?vue&type=script&lang=js"
export * from "./DivideCodePage.vue?vue&type=script&lang=js"
import style0 from "./DivideCodePage.vue?vue&type=style&index=0&id=74087b1f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74087b1f",
  null
  
)

export default component.exports